import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import config from "../../config";
import axios from "axios";
import {
  formatNumber,
  getRatingPercentage,
} from "../../Utils/utils";


const Home = () => {
  const [loading, setLoading] = useState(true);
  const [trustedbydata, setTrustedbydata] = useState([]);
  const [expertdata, setExpertdata] = useState([]);
  const [testimonialsdata, setTestimonialsdata] = useState([]);
  const [coursedata, setCoursedata] = useState([]);
  const [error, setError] = useState(null);

  const [showExpert, setShowExpert] = useState(false);
  const [showTestimonials, setShowTestimonials] = useState(false);
  const [modalData, setModalData] = useState({ name: "", image: "", description: "" });

  const handleOpenExpert = (item) => {
    setModalData({
      name: item.name,
      image: item.image,
      description: item.description.replace(/<[^>]*>/g, ''), // Remove HTML tags
    });
    setShowExpert(true);
  };

  const handleCloseExpert = () => {
    setShowExpert(false);
    setModalData({ name: "", image: "", description: "" });
  };

  const handleOpenTestimonials = (item) => {
    setModalData({
      name: item.name,
      image: item.image,
      description: item.description.replace(/<[^>]*>/g, ''), // Remove HTML tags
    });
    setShowTestimonials(true);
  };

  const handleCloseTestimonials = () => {
    setShowTestimonials(false);
    setModalData({ name: "", image: "", description: "" });
  };


  useEffect(() => {
    document.title = `Home | Agile Seekers`;
    document.getElementById("bodywrap").className = "homemain";


    // Define your API URL
    const apiUrl = `${config.API_BASE_URL}/home`;

    // Make Home the POST request using axios
    axios
      .post(apiUrl, {})
      .then((response) => {
        if (response.data.status === 1) {
          setTrustedbydata(response.data.data.trusted_by);
          setExpertdata(response.data.data.expert);
          setTestimonialsdata(response.data.data.testimonials);
          setCoursedata(response.data.data.course);
        } else {
          setError("Failed to load content");
          console.error("Error:", response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: true,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings1 = {
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  };

  var settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleClickScroll1 = () => {
    const element1 = document.getElementById("ccb1");
    if (element1) {
      element1.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [expanded, setExpanded] = useState({});

  const toggleContent = (index) => {
    setExpanded((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <>
      <Navbar />

      <Container>
        <Row className="hm-banner-box">
          <Col md={6} className="hm-banner-left">
            <h2>
              Transform your future by learning <span>TODAY</span>
            </h2>
            <p>
              From Learning to Earning - Certification Makes the Difference!
            </p>
            <Link to="/" onClick={() => handleClickScroll1()}>
              All Courses
              <Image
                src={`${config.BASE_URL}/assets/images/wh-arrow.png`}
                className="img-fluid"
                alt="tb1"
              />
            </Link>
            <div className="rbl-box">
              <div className="rbl-left">
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl1.png`}
                  className="img-fluid"
                  alt="rbl1"
                />
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl2.png`}
                  className="img-fluid"
                  alt="rbl2"
                />
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl3.png`}
                  className="img-fluid"
                  alt="rbl3"
                />
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl4.png`}
                  className="img-fluid"
                  alt="rbl4"
                />
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl5.png`}
                  className="img-fluid"
                  alt="rbl5"
                />
                <Image
                  src={`${config.BASE_URL}/assets/images/rbl6.png`}
                  className="img-fluid"
                  alt="rbl6"
                />
              </div>
              <div className="rbl-right">
                <p>Rated by Learners</p>
                <div>
                  <h5>4.9/5</h5>
                  <h6>3500+ Reviews</h6>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <Image
              src={`${config.BASE_URL}/assets/images/hm-banner.png`}
              className="img-fluid"
              fetchpriority="high"
              alt="hm-banner"
            />
          </Col>
        </Row>
      </Container>

      {/* Trusted By section */}
      <section className="tb-main logo-slider">
        <Container>
          <Row>
            <Col md={12}>
              <h3>Trusted By</h3>
            </Col>
          </Row>
          <Row>
            <Col className="tb-box">
              <Slider {...settings1}>
                {loading && <div>Loading...</div>}
                {!loading && error && <div>{error}</div>}
                {!loading &&
                  !error &&
                  trustedbydata.map((item, index) => (
                    <Image
                      src={item.image}
                      className="img-fluid"
                      alt="trusted-by"
                      id={item.id}
                      key={index}
                    />
                  ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Popular courses section */}
      <section className="popular-courses" id="ccb1">
        <Container>
          <Row>
            <Col md={12} className="pc-title">
              <h3>Popular Courses</h3>
            </Col>
          </Row>
          <Row>
            {loading && <Col>Loading...</Col>}
            {!loading && error && <Col>{error}</Col>}
            {!loading &&
              !error &&
              coursedata.map((item, index) => (
                <Col md={4} id={item.id} key={index} className="pcbox">
                  <div>
                    <div className="pctop">
                      <span>{item.category_name}</span>
                      <Link
                        to={`/${item.category_seo_slug}/${item.seo_slug}`}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        <Image
                          src={item.image}
                          className="img-fluid"
                          alt="pc1"
                        />
                      </Link>
                      <Image
                        src={item.certified_image}
                        className="img-fluid pct-abt"
                        alt="sa"
                      />
                    </div>
                    <div className="pcbot">
                      <Col>
                        <Col className="pcbotwrap">
                          <Link
                            to={`/${item.category_seo_slug}/${item.seo_slug}`}
                            onClick={() => {
                              window.scrollTo(0, 0);
                            }}
                          >
                            <h3>{item.name}</h3>
                          </Link>
                          <Row>
                            <Col className="pcbottxt">
                              <Image
                                src={`${config.BASE_URL}/assets/images/pctime.png`}
                                className="img-fluid"
                                alt="pctime"
                              />
                              <p>100% assured results</p>
                            </Col>
                            <Col className="pcbottxt">
                              <Image
                                src={`${config.BASE_URL}/assets/images/pcuser.png`}
                                className="img-fluid"
                                alt="pcuser"
                              />
                              <p>{item.training_days} Days Training</p>
                            </Col>
                          </Row>
                          <Row>
                            <div className="col pb-rate-view">
                              <div className="rating_bar">
                                <div
                                  className="rating-dis"
                                  style={{
                                    width: `${getRatingPercentage(
                                      item.rating
                                    )}%`,
                                  }}
                                ></div>
                              </div>
                              {/* <p>({item.rating} Reviews)</p> */}
                            </div>
                          </Row>
                          <Row className="pbplwrap">
                            <Col className="pbprice pe-0">
                              <h4>₹ {formatNumber(item.fee)}</h4>
                              <h5>₹{formatNumber(item.discount_fee)}</h5>
                            </Col>
                            <Col className="pblink text-end">
                              <Link
                                to={`/${item.category_seo_slug}/${item.seo_slug}`}
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                }}
                              >
                                Buy Course
                              </Link>
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                    </div>
                  </div>
                </Col>
              ))}
          </Row>
        </Container>
      </section>

      <section className="hm-learn">
        <Container>
          <Row>
            <Col>
              <h3>Learn from Experts Who've Been There and Done That</h3>
            </Col>
          </Row>
          <Row className="hmicnwrap mx-0">
            <Col md={3} xs={6}>
              <Row className="hmicn">
                <Col md={"auto"}>
                  <Image
                    src={`${config.BASE_URL}/assets/images/leicn1.png`}
                    className="img-fluid"
                    alt="leicn1"
                  />
                </Col>
                <Col>
                  <h4 className="leicn1">5000+</h4>
                  <p>Number of people trained</p>
                </Col>
              </Row>
            </Col>
            <Col md={3} xs={6}>
              <Row className="hmicn">
                <Col md={"auto"}>
                  <Image
                    src={`${config.BASE_URL}/assets/images/leicn2.png`}
                    className="img-fluid"
                    alt="leicn2"
                  />
                </Col>
                <Col>
                  <h4 className="leicn2">20</h4>
                  <p>Countries covered</p>
                </Col>
              </Row>
            </Col>
            <Col md={3} xs={6}>
              <Row className="hmicn">
                <Col md={"auto"}>
                  <Image
                    src={`${config.BASE_URL}/assets/images/leicn3.png`}
                    className="img-fluid"
                    alt="leicn3"
                  />
                </Col>
                <Col>
                  <h4 className="leicn3">99%</h4>
                  <p>Certification pass rate</p>
                </Col>
              </Row>
            </Col>
            <Col md={3} xs={6}>
              <Row className="hmicn">
                <Col md={"auto"}>
                  <Image
                    src={`${config.BASE_URL}/assets/images/leicn4.png`}
                    className="img-fluid"
                    alt="leicn4"
                  />
                </Col>
                <Col>
                  <h4 className="leicn4">23+</h4>
                  <p>Year of experience</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Expert Trainers section */}
      <section className="hm-oet-main">
        <Container fluid>
          <Row>
            <Col>
              <h3>Our Expert Trainers</h3>
            </Col>
          </Row>

          <Row>
            <Slider {...settings2}>
              {loading && <Col md={3}>Loading...</Col>}
              {!loading && error && <div>{error}</div>}
              {!loading &&
                !error &&
                expertdata.map((item, index) => (
                  <Col md={3} className="oet-box" id={item.id} key={index}>
                    <Row className="oet-top mx-0">
                      <Col>
                        <Image
                          src={item.image}
                          className="img-fluid"
                          alt="oet1"
                        />
                      </Col>
                    </Row>
                    <Row className="oet-bottom mx-0">
                      <Col md={12} className="oet-text">
                        <h4>{item.name}</h4>
                        <h5>{item.designation}</h5>
                      </Col>
                      <Col md={12}>


                        <div
                          className={item.description.length <= 100 ? "oet-cont-box" : ""}
                          dangerouslySetInnerHTML={{
                            __html: expanded[index]
                              ? `<p>${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .trim()}</p>` // Wrap the cleaned content in a <p> tag
                              : `<p class="oet-p">${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .slice(0, 100)
                                .trim()}${item.description.length > 100 ? '...' : ''}</p>`, // Truncate if necessary
                          }}
                        />
                        {item.description.length > 100 && (
                          <div className="read-more-main">
                            <span
                              className="read-more"
                              // onClick={() => toggleContent(index)}
                              onClick={() => handleOpenExpert(item)}

                            >
                              {expanded[index] ? " Read less" : " Read more"}
                            </span>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ))}
            </Slider>
          </Row>
        </Container>
      </section>

      {/* Testimonials from Our Learners section */}
      <section className="hm-testimonial">
        <Container fluid>
          <Row>
            <Col className="hm-testi-top">
              <p>Why They Trust Us</p>
              <h3>Testimonials from Our Learners</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <Slider {...settings}>
                {loading && (
                  <Col md={4} className="hm-testimain">
                    Loading...
                  </Col>
                )}
                {!loading && error && <div>{error}</div>}
                {!loading &&
                  !error &&
                  testimonialsdata.map((item, index) => (
                    <Col
                      md={4}
                      id={item.id}
                      key={index}
                      className="hm-testimain"
                    >
                      <Col className="testibox">
                        <div className="rating_bar">
                          <div
                            className="rating-dis"
                            style={{
                              width: `${getRatingPercentage(item.rating)}%`,
                            }}
                          ></div>
                        </div>
                        {/* Toggle Description */}
                        {/* <ReadMoreToggle
                          description={item.description}
                        /> */}


                        <div
                          className={item.description.length <= 100 ? "testi-cont-box" : ""}
                          dangerouslySetInnerHTML={{
                            __html: expanded[index]
                              ? `<p>"${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .trim()}"</p>` // Wrap the cleaned content in a <p> tag
                              : `<p class="testi-p">"${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .slice(0, 100)
                                .trim()}${item.description.length > 100 ? '...' : ''}"</p>`, // Truncate if necessary
                          }}
                        />
                        {item.description.length > 100 && (
                          <div className="read-more-main">
                            <span
                              className="read-more"
                              // onClick={() => toggleContent(index)}
                              onClick={() => handleOpenTestimonials(item)}

                            >
                              {expanded[index] ? " Read less" : " Read more"}
                            </span>
                          </div>
                        )}


                        <div>
                          <div>
                            <h4>{item.name}</h4>
                            <h5>{item.designation}</h5>
                          </div>
                          <a
                            href={item.linkedin_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Image
                              src={`${config.BASE_URL}/assets/images/linkedin-blue.png`}
                              className="img-fluid"
                              alt="linkedin-blue"
                            />
                          </a>
                        </div>
                      </Col>
                      <div className="testiborder"> </div>
                      <div className="testiuserbox">
                        <div
                          style={{ backgroundImage: `url(${item.image})` }}
                        ></div>
                      </div>
                    </Col>
                  ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="hm-about-main">
        <Container>
          <Row>
            <Col md={5}>
              <Image
                src={`${config.BASE_URL}/assets/images/hm-about.png`}
                className="img-fluid"
                alt="hm-about"
              />
            </Col>
            <Col md={7}>
              <Row className="ham-top">
                <Col md={12}>
                  <h3>About Us</h3>
                  <Image
                    src={`${config.BASE_URL}/assets/images/plan.png`}
                    className="img-fluid"
                    alt="plan"
                  />
                </Col>
                <Col md={12}>
                  <p>
                    Agile transformation is the process of transitioning an
                    entire organization to one that can embrace and thrive in a
                    flexible, collaborative, self-organizing, fast-changing
                    environment. Many organizations have been building software
                    and related products for years. The world has decided to
                    move much faster and build smaller software in incremental
                    steps. The complete cultural and organizational mind set
                    must change to one that embraces a culture of
                    self-organization and collaboration. An agile transformation
                    changes the fundamental DNA of an organization.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col md={12} lg={6}>
                  <Col className="ham-orange">
                    <Col>
                      <Col className="text-end">
                        <Image
                          src={`${config.BASE_URL}/assets/images/au-star.png`}
                          className="img-fluid"
                          alt="au-star"
                        />
                      </Col>
                      <Col>
                        <Image
                          src={`${config.BASE_URL}/assets/images/au-view.png`}
                          className="img-fluid"
                          alt="au-view"
                        />
                        <h5>Our Vision</h5>
                      </Col>
                    </Col>
                    <p>
                      To be always the most desired place for reliable learning
                      and inspiring people globally by spreading Agile
                      exuberantly.
                    </p>
                  </Col>
                </Col>
                <Col md={12} lg={6}>
                  <Col className="ham-orange">
                    <Col>
                      <Col className="text-end">
                        <Image
                          src={`${config.BASE_URL}/assets/images/au-star.png`}
                          className="img-fluid"
                          alt="au-star"
                        />
                      </Col>
                      <Col>
                        <Image
                          src={`${config.BASE_URL}/assets/images/au-mission.png`}
                          className="img-fluid"
                          alt="au-view"
                        />
                        <h5>Our Mission</h5>
                      </Col>
                    </Col>
                    <p>
                      Deliver business value to our customers by coaching and
                      mentoring people to foster an agile culture in
                      enterprises.
                    </p>
                  </Col>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Expert Trainers Description Modal */}
      <Modal
        show={showExpert}
        onHide={handleCloseExpert}
        centered
        className="thank-popup"
        backdrop="static"
      >
        <Modal.Body>
          <Col>
            {/* <Image src={modalData.image} className="img-fluid mb-3" alt={modalData.name} /> */}
            {/* <h3>{modalData.name}</h3> */}
            <p>{modalData.description}</p>
            <Link onClick={handleCloseExpert} className="btn btn-primary">OK</Link>
          </Col>
        </Modal.Body>
      </Modal>

      {/* Testimonials from Our Learners Description Modal */}
      <Modal
        show={showTestimonials}
        onHide={handleCloseTestimonials}
        centered
        className="thank-popup"
        backdrop="static"
      >
        <Modal.Body>
          <Col>
            {/* <Image src={modalData.image} className="img-fluid mb-3" alt={modalData.name} /> */}
            {/* <h3>{modalData.name}</h3> */}
            <p>"{modalData.description}"</p>
            <Link onClick={handleCloseTestimonials} className="btn btn-primary">OK</Link>
          </Col>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default Home;
